import { render, staticRenderFns } from "./roles-permissions.vue?vue&type=template&id=07b85eb6&scoped=true&"
import script from "./roles-permissions.vue?vue&type=script&lang=js&"
export * from "./roles-permissions.vue?vue&type=script&lang=js&"
import style0 from "./roles-permissions.vue?vue&type=style&index=0&id=07b85eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b85eb6",
  null
  
)

component.options.__file = "roles-permissions.vue"
export default component.exports